/**
 * extractEncodedIdFromPlayerDetail.ts
 *
 * Resolves a Firework encoded id from mixed transition payload shapes.
 */

/**
 * Extract encoded video id from Firework player transition event details.
 */
export function extractEncodedIdFromPlayerDetail(detail: unknown): string | undefined {
  if (!detail || typeof detail !== "object") return undefined;

  const eventDetail = detail as Record<string, unknown>;
  const directValue =
    eventDetail.encodedId ??
    eventDetail.encoded_id ??
    eventDetail.videoId ??
    eventDetail.video_id ??
    eventDetail.video ??
    eventDetail.id;

  if (typeof directValue === "string" && directValue.trim()) {
    return directValue.trim();
  }

  const playerName = eventDetail.playerName ?? eventDetail.player_name ?? eventDetail.name;
  if (typeof playerName === "string" && playerName.startsWith("player-")) {
    return playerName.slice("player-".length);
  }

  return undefined;
}
